<script lang="ts">
import { tv } from 'tailwind-variants';
import MonospaceLogo from '~/assets/img/monospace-logo-color.svg';

export interface DynamicLogoProps {
	size?: 'sm' | 'md' | 'lg';
	icon?: string;
}

const containerTv = tv({
	base: 'flex items-center justify-center overflow-hidden rounded-md',
	variants: {
		size: {
			sm: 'size-9',
			md: 'size-12',
			lg: 'size-20',
		},
	},
	defaultVariants: {
		size: 'sm',
	},
});

const iconTv = tv({
	base: 'text-muted',
	variants: {
		size: {
			sm: 'size-5',
			md: 'size-5',
			lg: 'size-6',
		},
	},
	defaultVariants: {
		size: 'sm',
	},
});
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<DynamicLogoProps>(), {
	size: 'sm',
});

const containerClass = computed(() => containerTv({ size: props.size }));
const iconClass = computed(() => iconTv({ size: props.size }));
</script>

<template>
	<div class="text-(--brand-color,var(--color-primary))" :class="[containerClass]">
		<slot>
			<DIcon
				v-if="icon"
				:name="icon"

				:class="iconClass"
			/>
			<MonospaceLogo
				v-else

				class="size-full object-contain"
			/>
		</slot>
	</div>
</template>
